import React from "react";
import logo from "./../../assets/images/logo.png";

import { AiOutlineWhatsApp } from 'react-icons/ai';
import { MdOutlineEmail } from 'react-icons/md';
import { ImLocation2 } from 'react-icons/im';
import { Link } from "react-router-dom";
import './Footer.css'
const Footer = () => {
  return (
    <>
      <div className="mainContainerFooter">
        <div className="topCol1Footer">
          <img src={logo}  className="logoFooterImg" />
          
        </div>
        <div className="secondColFooter">
          <div className="firstRowTxtHdr">Company</div>
          <div className="topFooterConten">

          <div>  <Link to="/customer/ourServices"> Our Services</Link></div>
          <div> <Link to="/customer/ourFleets">Our Fleets</Link></div>
          <div>  <Link to="/customer/driveWithUs">Drive With Us</Link></div>
          <div>   <Link to="/customer/contactUs">Contact US</Link></div>
          </div>
          
        </div>
        {/* <div className="secondColFooter">
        <div className="firstRowTxtHdr" >Contact</div>
          <div ><AiOutlineWhatsApp/> <span> Our Fleet</span></div>
          <div><MdOutlineEmail/> <span>Drive With US</span></div>
          <div><ImLocation2/> <span>Contact US</span></div>
          
        </div> */}
      </div>
    </>
  );
};

export default Footer;
